
        var result = require("!!../../../../node_modules/css-loader/index.js!./treatment-info.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/management/treatment-info/treatment-info.component.css
// module id = 2501
// module chunks = 1